import { Skeleton } from '@pmi/dsm-react';

export default function SkeletonLoader() {
  return (
    <ul className="list-group">
      {[0, 1].map((i) => (
        <li className="list-group-item mb-3 border p-4" key={i}>
          <div className="row mb-3">
            <div className="ps-3" style={{ width: 85 }}>
              <Skeleton
                animation="wave"
                variant="circle"
                width={50}
                height={50}
              />
            </div>
            <div className="col p-0">
              <Skeleton animation="wave" height={20} width="90%" />
              <Skeleton animation="wave" height={20} width="70%" />
              <Skeleton animation="wave" height={20} width="50%" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
